import { StyledBanner, StyledEmoji, StyledImage } from './styles';

const GemAcquisitionBanner = () => {
  return (
    <StyledBanner>
      <StyledEmoji>🎉</StyledEmoji>
      InterviewPlanner has been acquired by
      <StyledImage src="/scheduling/src/assets/images/gem-logotype.svg" />
      &mdash;&nbsp;<a href="https://www.gem.com/blog/why-were-excited-to-acquire-interviewplanner-the-intelligent-scheduling">Learn more!</a>
    </StyledBanner>
  );
};

export default GemAcquisitionBanner;
